type ServiceVersions = {
  stable: string;
  latest: string;
};
export type VersionType = keyof ServiceVersions;

type ServiceName = 'commerce' | 'shipping'; // Add more service names when needed
type ApiVersions = Partial<Record<ServiceName, ServiceVersions>>;

// Add more services when needed, for now there is only below services
// that need versioning. Dont forget to add the service to the serviceName type.
const apiVersions: ApiVersions = {
  commerce: {
    stable: 'v3',
    latest: 'v4',
  },
};

export const resolveApiVersion = (
  url: string,
  serviceName: ServiceName,
  versionType: VersionType = 'stable',
) => {
  // Remove trailing slashes from the URL if there is any.
  const cleanedUrl = url.replace(/\/+$/, '');

  const service = apiVersions[serviceName] && apiVersions[serviceName];
  const serviceVersion = service && service[versionType];

  if (!serviceVersion) {
    return url;
  }

  // Add the version to the end of the cleaned URL
  const modifiedUrl = `${cleanedUrl}/${serviceVersion}`;
  return modifiedUrl;
};
